import api from "../services/api";

export const SEARCH_CITIES_START = "SEARCH_CITIES_START";
export const SEARCH_CITIES_SUCCESS = "SEARCH_CITIES_SUCCESS";
export const SEARCH_CITIES_ERROR = "SEARCH_CITIES_ERROR";

export const SEARCH_NEARBYCITIES_START = "SEARCH_NEARBYCITIES_START";
export const SEARCH_NEARBYCITIES_SUCCESS = "SEARCH_NEARBYCITIES_SUCCESS";
export const SEARCH_NEARBYCITIES_ERROR = "SEARCH_NEARBYCITIES_ERROR";

export function onSearchCitiesStart() {
  return {
    type: SEARCH_CITIES_START
  };
}

export function onSearchCitiesSuccess(data) {
  return {
    type: SEARCH_CITIES_SUCCESS,
    data
  };
}

export function onSearchCitiesError(error) {
  return {
    type: SEARCH_CITIES_ERROR,
    error
  };
}

export function onSearchNearbyCitiesStart() {
  return {
    type: SEARCH_NEARBYCITIES_START
  };
}

export function onSearchNearbyCitiesSuccess(data) {
  return {
    type: SEARCH_NEARBYCITIES_SUCCESS,
    data
  };
}

export function onSearchNearbyCitiesError(error) {
  return {
    type: SEARCH_NEARBYCITIES_ERROR,
    error
  };
}

export function searchCitiesAutocomplete(query) {
  return dispatch => {
    dispatch(onSearchCitiesStart());
    api
      .searchCitiesAutocomplete(query)
      .then(res => {
        dispatch(onSearchCitiesSuccess(res.data));
      })
      .catch(error => {
        dispatch(onSearchCitiesError(error.response));
      });
  };
}

export function searchNearbyCitiesByPlaceId(placeId) {
  return dispatch => {
    dispatch(onSearchNearbyCitiesStart());
    api
      .getPlaceDetails(placeId)
      .then(res => {
        const { lat, lng } = res.data.data.result.geometry.location;
        dispatch(searchNearbyCities(lat.toString(), lng.toString()));
      })
      .catch(error => {
        dispatch(onSearchNearbyCitiesError(error.response));
      });
  };
}

export function searchNearbyCities(lat, lng) {
  return dispatch => {
    dispatch(onSearchNearbyCitiesStart());
    api
      .searchNearbyCities(lat, lng)
      .then(res => {
        dispatch(onSearchNearbyCitiesSuccess(res.data));
      })
      .catch(error => {
        dispatch(onSearchNearbyCitiesError(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/cities.actions.js